export default __webpack_public_path__ + "static/media/page_banner_img.f7dc474f.jpg";